import { render, staticRenderFns } from "./ChildrenInfo.vue?vue&type=template&id=9ba54a34&scoped=true"
import script from "./ChildrenInfo.vue?vue&type=script&lang=ts"
export * from "./ChildrenInfo.vue?vue&type=script&lang=ts"
import style0 from "./ChildrenInfo.vue?vue&type=style&index=0&id=9ba54a34&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ba54a34",
  null
  
)

export default component.exports